import { Redirect, useLocation } from "react-router-dom";

/**
 * Sends `/` to `/assistent` with the query string intact. A plain `<Redirect to="/assistent" />` drops it, so
 * campaign links to the root lost their utm_* parameters before AssistantOverview reported the touchpoint.
 */
export default function RootRedirect() {
    const { search } = useLocation();

    return <Redirect to={{ pathname: "/assistent", search }} />;
}
